import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { useTranslation } from '@lt/localization';

import ReviewsList from './ReviewsList';

const baseCls = 'lt-hotel-reviews';

const ReviewsDesktop = ({ hotelName }) => {
  const { t } = useTranslation();

  return (
    <StyledContainer className={baseCls}>
      <StyledH2>
        {t('hotel.reviews.title')} {hotelName}
      </StyledH2>
      <div className={`${baseCls}__row`}>
        <div className={`${baseCls}__list`}>
          <div className={`${baseCls}__items`}>
            <ReviewsList />
          </div>
        </div>
      </div>
    </StyledContainer>
  );
};

const StyledH2 = styled.h2`
  margin: 0 0 4px 4px;
  color: var(--black);
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
`;

const StyledContainer = styled.div`
  padding: 4px 4px 90px 4px;
`;

ReviewsDesktop.propTypes = {
  hotelName: PropTypes.string.isRequired,
};

export default ReviewsDesktop;
